import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController,ModalController,IonRouterOutlet,ActionSheetController } from '@ionic/angular';
import { ExpenseaddPage } from '../expenseadd/expenseadd.page';

@Component({
  selector: 'app-profit',
  templateUrl: './profit.page.html',
  styleUrls: ['./profit.page.scss'],
})

export class ProfitPage implements OnInit {
  
 data:any;
 text:any;
 user:any;
 total:any;
 show = false;
 from:any;
 to:any;
 q:any;
 bars: any;
 colorArray: any;
date:any;
 f:any;
  constructor(public actionSheetController: ActionSheetController,private routerOutlet: IonRouterOutlet,public modalController: ModalController,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

  this.user = JSON.parse(localStorage.getItem('user_data'));
  this.text = JSON.parse(localStorage.getItem('app_text'));

  }

  ngOnInit()
  {
    this.loadData();
  }

  showPre()
  {
    this.show = this.show == true ? false : true;

    if(!this.show)
    {
      this.from = undefined;
      this.to   = undefined;

      return this.loadData();
    }
  }



  async loadData(id = 0)
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.getProfit(id,this.from,this.to).subscribe((response:any) => {

    this.data   = response.data;

    loading.dismiss();

    });
  }

 
  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }

}
